import React from 'react'

export const ConfirmDelete = ({ setDeleteNote, onConfirmDelete, onNotConfirmDelete }) => {
    return (
        <div className='confirmDelete'>
            <div className="deleteBox">
                <p>Are you sure to Delete Note?</p>
                <div className="btn">
                    <button onClick={onConfirmDelete}>Yes</button>
                    <button onClick={onNotConfirmDelete}>No</button>
                </div>
            </div>
        </div>
    )
}
